import { Navigate, useParams } from "react-router-dom";

export default function UniversityStudentsReportRedirectPage() {
  const { universityId } = useParams();
  return <Navigate to={`/education/universities/${universityId}/reports/semester`} replace />;
}
